export const FETCH_ADMIN_TAGS = 'FETCH_ADMIN_TAGS';
export const SET_ADMIN_TAGS = 'SET_ADMIN_TAGS';

export const UPDATE_TAG_STATUS = 'UPDATE_TAG_STATUS';
export const SET_TAG_STATUS = 'SET_TAG_STATUS';
